<template>
  <div class="container grid-list-xl">
    <v-layout row wrap>
      <v-flex d-flex lg6 sm12>
        <v-json-editor style="height: 100%;" @json-change="onJsonChange" v-model="jsonSchema"></v-json-editor>
      </v-flex>
      <v-flex d-flex lg6 sm12>
        <v-jsf v-model="formModel" @change="onFormModelChange" :schema="jsonSchema" :options="{}"></v-jsf>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
    props: ['value'],
    data() {
        return {
            valid: false,
            formModel: {},
            jsonSchema: this.value,
        }
    },
    methods: {
        onJsonChange(value) {
            this.$emit('input', value);
            this.$emit('formModelChange', this.formModel);
        },
        onFormModelChange() {
          this.$emit('formModelChange', this.formModel);
        }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/forms/JSONFormEditor.vue